import React, { useState, useRef, useCallback } from 'react';
import styled from 'styled-components';
import { FiSearch } from 'react-icons/fi';
import { FiEdit3, FiChevronRight } from 'react-icons/fi';
import { FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useNoobookContext } from '../context/NoobookContext';
import { useEffect } from 'react';
import { getAccessToken } from '../react-queries/queries';
import { processApiResponse } from '../common/errorMessage';
import { getBookeventsByHashtag } from '../api/BookeventApi';
import { BookEventType } from '../common/enums';
import ReviewMoimDetailPage from './ReviewMoimDetailPage';
import MoimRecruitPage from './MoimRecruitPage';

const PageWrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  background: #f5f5f5;
`;


const SectionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 20px 10px 20px;
  margin-top: 0;
`;
const SectionTitle = styled.div`
  font-size: 17px;
  font-weight: 400;
  color: #222;
  display: flex;
  align-items: center;
  gap: 6px;
`;
const SectionBtn = styled.button`
  background: none;
  border: none;
  color: #888;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;
const MoreBtn = styled.button`
  background: none;
  border: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 0;
  color: #999;
  font-size: 13px;
  line-height: 1;

  &:hover {
    color: #777;
  }
`;
const MoreCircle = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #ddd;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
const MoimList = styled.div`
  margin: 0 20px 0 20px;
`;
const MoimItem = styled.div`
  display: flex;
  gap: 14px;
  margin-bottom: 22px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  opacity: ${({ $expired }) => ($expired ? 0.45 : 1)};
  filter: ${({ $expired }) => ($expired ? 'grayscale(0.35)' : 'none')};
  transition: opacity 0.2s, filter 0.2s;
`;
const MoimThumb = styled.img`
  width: 120px;
  height: 80px;
  max-width: 120px;
  max-height: 80px;
  min-width: 120px;
  min-height: 80px;
  border-radius: 0;
  object-fit: cover;
  background: #eee;
  flex-shrink: 0;
`;
const MoimInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  overflow: hidden;
`;
const MoimTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
`;
const MoimTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #222;
  margin-bottom: 0;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  line-height: 1.4;
`;
const MoimBadge = styled.div`
  background: ${({ children }) => {
    if (typeof children === 'string' && (children.includes('오프라인') || children.includes('온라인'))) return '#acacac';
    if (typeof children === 'string' && children.includes('필사단')) return '#d8a024';
    return '#1976d2';
  }};
  color: #fff;
  font-size: 13px;
  border-radius: 4px;
  padding: 2px 4px;
  white-space: nowrap;
  display: inline-block;
  font-weight: 400;
  margin-left: 4px;
`;
const MoimDesc = styled.div`
  font-size: 14px;
  color: #444;
  margin-bottom: 2px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
`;
const MoimSub = styled.div`
  font-size: 13px;
  color: #888;
  margin-bottom: 2px;
`;
const MoimTags = styled.div`
  font-size: 12px;
  color: #7d7d7d;
  margin-top: 2px;
  font-weight: 500;
`;
const ContentSection = styled.div`
  background: #fff;
  padding-bottom: 80px;
`;
const WhiteSpacer = styled.div`
  height: 20px;
  background: #fff;
`;



const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;

const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 0px 20px 0px;
`;

const LoadingText = styled.div`
  text-align: center;
  padding: 20px;
  color: #888;
  font-size: 14px;
`;



const EditButton = styled.button`
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background: #1565c0;
  }
`;

const EditModal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

const EditModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;

const EditModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;

const EditCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const EditModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;

const isRecruitEnded = (recruitTo) => {
  if (!recruitTo) return false;
  const end = new Date(recruitTo);
  if (Number.isNaN(end.getTime())) return false;
  end.setHours(23, 59, 59, 999);
  return new Date() > end;
};

const EventDetailModal = ({ bookEventId, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  return (
    <Modal>
      <ModalHeader>
        <ModalTitle>북이벤트 상세</ModalTitle>
        <CloseButton onClick={() => onClose(false)}>
          <FaTimes />
        </CloseButton>
      </ModalHeader>
      <ModalContent id="noobook-page-modal">
        <ReviewMoimDetailPage bookEventId={bookEventId} onDeleted={() => onClose(true)}/>
      </ModalContent>
    </Modal>
  )
};

const EventListModal = ({ eventTitle, closeBtnClick, eventList, eventListItemClick, onScroll, modalLoading, hasMoreList }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  return (
    <Modal>
      <ModalHeader>
        <ModalTitle>{eventTitle}</ModalTitle>
        <CloseButton onClick={closeBtnClick}>
          <FaTimes />
        </CloseButton>
      </ModalHeader>
      <ModalContent onScroll={onScroll}>
        <MoimList>
          {eventList?.map((item, i) => (
            <MoimItem
              key={item.id ?? i}
              $expired={isRecruitEnded(item.recruitTo)}
              onClick={() => eventListItemClick(item.id)}
              style={{ cursor: 'pointer' }}
            >
              <MoimThumb src={item.imgUrl || '/book_sample.jpg'} alt={item.title} />
              <MoimInfo>
                <MoimTitleRow>
                  <MoimTitle>{item.title}</MoimTitle>
                  <MoimBadge>{`${item.eventType == BookEventType.RECRUIT_REVIEWER ? '서평단 ' : '필사단 '}${item.recruitNum}명`}</MoimBadge>
                </MoimTitleRow>
                <MoimDesc>{item.briefIntroduction || '-'}</MoimDesc>
                <MoimTags>
                  {item.tags || (item.hashtags && item.hashtags.length > 0 ? '#' + item.hashtags.join(' #') : '')}
                </MoimTags>
              </MoimInfo>
            </MoimItem>
          ))}
          {modalLoading && <LoadingText>로딩 중...</LoadingText>}
          {!hasMoreList && eventList?.length > 0 && (
            <LoadingText>모든 목록을 불러왔습니다.</LoadingText>
          )}
        </MoimList>
      </ModalContent>
    </Modal>
  );
};



const PAGE_SIZE = 20;

export function ReviewMoimPage({keyword}) {
  //const [tab, setTab] = useState('review');
  const [searchKeyword, setSearchKeyword] = useState(keyword);
  const [deadlineMoimList, setDeadlineMoimList] = useState([]);
  const [newMoimList, setNewMoimList] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // 모달 관련 상태
  const [showDeadlineModal, setShowDeadlineModal] = useState(false);
  const [showNewModal, setShowNewModal] = useState(false);
  const [modalDeadlineList, setModalDeadlineList] = useState([]);
  const [modalNewList, setModalNewList] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [hasMoreDeadline, setHasMoreDeadline] = useState(true);
  const [hasMoreNew, setHasMoreNew] = useState(true);
  const [deadlinePage, setDeadlinePage] = useState(0);
  const [newPage, setNewPage] = useState(0);
  
  // 이벤트 상세 모달 관련 상태
  const [showEventDetailModal, setShowEventDetailModal] = useState(false);
  const [selectedBookEventId, setSelectedBookEventId] = useState(null);

  const [showEditModal, setShowEditModal] = useState(false);
  const [isModified, setIsModified] = useState(false);
  
  //const handleTab = t => setTab(t);
  const navigate = useNavigate();
  //const { setShowBack } = useNoobookContext();
  
  //useEffect(() => {
    //setShowBack(false);
  //}, []);

  // 초기 데이터 설정
  useEffect(() => {
    //console.log('ReviewMoimPage : ',keyword, searchKeyword);
    setSearchKeyword(keyword);
  }, [keyword]);


  useEffect(() => { 
    searchBookevents(searchKeyword);
  }, [searchKeyword]);

  useEffect(() => {
    if(isModified) {
      searchBookevents(searchKeyword);
      setIsModified(false);
    }
  }, [isModified]);




  // 모달에서 마감임박 목록 로드
  const loadModalDeadlineList = useCallback(async (page = 0, append = false) => {
    if (modalLoading || (!hasMoreDeadline && page > 0)) return;
    
    setModalLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      
      const response = await getBookeventsByHashtag(
        accessToken || '', 
        searchKeyword.trim() || '', 
        true, 
        page, 
        PAGE_SIZE
      );
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        const newData = processedResponse.data || [];
        if (append) {
          setModalDeadlineList(prev => [...prev, ...newData]);
        } else {
          setModalDeadlineList(newData);
        }
        setHasMoreDeadline(newData.length === PAGE_SIZE);
        setDeadlinePage(page);
      } else {
        console.error('마감임박 목록 로드 실패:', processedResponse.errorMessage);
      }
    } catch (error) {
      console.error('마감임박 목록 로드 중 오류:', error);
    } finally {
      setModalLoading(false);
    }
  }, [searchKeyword, modalLoading, hasMoreDeadline]);

  // 모달에서 신규 서평단 모집 목록 로드
  const loadModalNewList = useCallback(async (page = 0, append = false) => {
    if (modalLoading || (!hasMoreNew && page > 0)) return;
    
    setModalLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      
      const response = await getBookeventsByHashtag(
        accessToken || '', 
        searchKeyword.trim() || '', 
        false, 
        page, 
        PAGE_SIZE
      );
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        const newData = processedResponse.data || [];
        if (append) {
          setModalNewList(prev => [...prev, ...newData]);
        } else {
          setModalNewList(newData);
        }
        setHasMoreNew(newData.length === PAGE_SIZE);
        setNewPage(page);
      } else {
        console.error('신규 서평단 모집 목록 로드 실패:', processedResponse.errorMessage);
      }
    } catch (error) {
      console.error('신규 서평단 모집 목록 로드 중 오류:', error);
    } finally {
      setModalLoading(false);
    }
  }, [searchKeyword, modalLoading, hasMoreNew]);

  // 마감임박 모달 열기
  const openDeadlineModal = () => {
    setShowDeadlineModal(true);
    setModalDeadlineList([]);
    setDeadlinePage(0);
    setHasMoreDeadline(true);
    loadModalDeadlineList(0, false);
  };

  // 신규 서평단 모집 모달 열기
  const openNewModal = () => {
    setShowNewModal(true);
    setModalNewList([]);
    setNewPage(0);
    setHasMoreNew(true);
    loadModalNewList(0, false);
  };

  // 모달에서 아이템 클릭 시 상세 모달 열기
  const handleBookEventItemClick = useCallback((bookEventId) => {
    setSelectedBookEventId(bookEventId);
    setShowEventDetailModal(true);
  }, []);

  // 상세 모달 닫기
  const closeEventDetailModal = (isModified = false) => {
    setShowEventDetailModal(false);
    setSelectedBookEventId(null);
    if(isModified) {
      setIsModified(true);
      if(showDeadlineModal) {
        loadModalDeadlineList(0, false);
      } else if(showNewModal) {
        loadModalNewList(0, false);
      }
    }
  };

  // 무한 스크롤 핸들러
  const handleDeadlineScroll = useCallback((e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 100 && hasMoreDeadline && !modalLoading) {
      loadModalDeadlineList(deadlinePage + 1, true);
    }
  }, [deadlinePage, hasMoreDeadline, modalLoading, loadModalDeadlineList]);

  const handleNewScroll = useCallback((e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 100 && hasMoreNew && !modalLoading) {
      loadModalNewList(newPage + 1, true);
    }
  }, [newPage, hasMoreNew, modalLoading, loadModalNewList]);

  // 해시태그로 북이벤트 검색
  const searchBookevents = async (keyword) => {
    if (loading) return;

    console.log('searchBookevents : ',keyword, searchKeyword);
    
    const fSearchKeyword = keyword || searchKeyword;
    setLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      
      // 마감임박 목록 (sortAsc: false, page: 0, size: 3)
      const deadlineResponse = await getBookeventsByHashtag(
        accessToken || '', 
        fSearchKeyword.trim(), 
        true, 
        0, 
        5
      );
      const processedDeadlineResponse = processApiResponse(deadlineResponse);
      
      if (processedDeadlineResponse.success) {
        setDeadlineMoimList(processedDeadlineResponse.data || []);
      } else {
        console.error('마감임박 목록 로드 실패:', processedDeadlineResponse.errorMessage);
        setDeadlineMoimList([]);
      }
      
      // 신규 서평단 모집 목록 (sortAsc: true, page: 0, size: 3)
      const newResponse = await getBookeventsByHashtag(
        accessToken || '', 
        fSearchKeyword.trim(), 
        false, 
        0, 
        5
      );
      const processedNewResponse = processApiResponse(newResponse);
      
      if (processedNewResponse.success) {
        setNewMoimList(processedNewResponse.data || []);
      } else {
        console.error('신규 서평단 모집 목록 로드 실패:', processedNewResponse.errorMessage);
        setNewMoimList([]);
      }
      
    } catch (error) {
      console.error('북이벤트 검색 중 오류:', error);
      setDeadlineMoimList([]);
      setNewMoimList([]);
    } finally {
      setLoading(false);
    }
  };

  /*
  // 검색어 입력 처리
  const handleSearchInputChange = (e) => {
    console.log('handleSearchInputChange : ',e.target.value);
    setSearchKeyword(e.target.value);
  };

  // 검색어 입력 후 Enter 키 처리
  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      searchBookevents();
    }
  };
*/
  const openEditModal = () => {
    setShowEditModal(true);
  };

  // 수정 모달 닫기
  const closeEditModal = (modified) => {
    setShowEditModal(false);
    if(modified) {
      setIsModified(true);
    }
  };

  // 뒤로가기 버튼으로 모달 닫기
  useEffect(() => {
    const handlePopState = (event) => {
      if (showDeadlineModal) {
        event.preventDefault();
        setShowDeadlineModal(false);
        // history를 다시 push하여 뒤로가기 이벤트를 취소
        //window.history.pushState(null, '', window.location.href);
      } else if (showNewModal) {
        event.preventDefault();
        setShowNewModal(false);
        // history를 다시 push하여 뒤로가기 이벤트를 취소
        //window.history.pushState(null, '', window.location.href);
      } else if (showEventDetailModal) {
        event.preventDefault();
        closeEventDetailModal();
        // history를 다시 push하여 뒤로가기 이벤트를 취소
        //window.history.pushState(null, '', window.location.href);
      } else if (showEditModal) {
        event.preventDefault();
        closeEditModal(false);
        // history를 다시 push하여 뒤로가기 이벤트를 취소
        //window.history.pushState(null, '', window.location.href);
      }
    };

    // 모달이 열려있을 때만 history state를 push하고 이벤트 리스너 등록
    if (showDeadlineModal || showNewModal || showEventDetailModal || showEditModal) {
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('popstate', handlePopState);
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [showDeadlineModal, showNewModal, showEventDetailModal, showEditModal]);
      

  return (
    <PageWrapper>
      
      <ContentSection>
        
          <>
            <WhiteSpacer />
            <SectionRow>
              <SectionTitle>
                마감임박
                <MoreBtn type="button" onClick={openDeadlineModal} aria-label="마감임박 더보기">
                  <MoreCircle>
                    <FiChevronRight size={12} />
                  </MoreCircle>
                  더보기
                </MoreBtn>
              </SectionTitle>
              <SectionBtn onClick={()=>/*navigate('/moim-recruit')*/openEditModal()}><FiEdit3 size={16} /> 서평·필사단 모집하기</SectionBtn>
            </SectionRow>
            <MoimList>
              {deadlineMoimList.length > 0 ? (
                deadlineMoimList.map((item, i) => (
                  <MoimItem
                    key={i}
                    $expired={isRecruitEnded(item.recruitTo)}
                    onClick={() => /*navigate(`/review-moim-detail?bookEventId=${item.id}`)*/handleBookEventItemClick(item.id)}
                    style={{cursor:'pointer'}}
                  >
                    <MoimThumb src={item.imgUrl || '/book_sample.jpg'} alt={item.id} />
                    <MoimInfo>
                      <MoimTitleRow>
                        <MoimTitle>{item.title}</MoimTitle>
                        <MoimBadge>{`${item.eventType==BookEventType.RECRUIT_REVIEWER ? '서평단 ' : '필사단 '}${item.recruitNum}명`}</MoimBadge>
                      </MoimTitleRow>
                      <MoimDesc>{item.briefIntroduction || '-'}</MoimDesc>
                      <MoimTags>{item.tags || (item.hashtags && item.hashtags.length > 0 ? '#'+item.hashtags.join(' #') : '')}</MoimTags>
                    </MoimInfo>
                  </MoimItem>
                ))
              ) : (
                <div style={{textAlign: 'center', color: '#888', padding: '24px 0'}}>
                  마감 임박한 모집이 없습니다.
                </div>
              )}
            </MoimList>
            <SectionRow style={{marginTop:32}}>
              <SectionTitle>
                신규 서평단 모집
                <MoreBtn type="button" onClick={openNewModal} aria-label="신규 서평단 모집 더보기">
                  <MoreCircle>
                    <FiChevronRight size={12} />
                  </MoreCircle>
                  더보기
                </MoreBtn>
              </SectionTitle>
            </SectionRow>
            <MoimList>
              {newMoimList.map((item, i) => (
                <MoimItem
                  key={i}
                  $expired={isRecruitEnded(item.recruitTo)}
                  onClick={() => /*navigate(`/review-moim-detail?bookEventId=${item.id}`)*/handleBookEventItemClick(item.id)}
                  style={{cursor:'pointer'}}
                >
                  <MoimThumb src={item.imgUrl || '/book_sample.jpg'} alt={item.id} />
                  <MoimInfo>
                    <MoimTitleRow>
                      <MoimTitle>{item.title}</MoimTitle>
                      <MoimBadge>{`${item.eventType==BookEventType.RECRUIT_REVIEWER ? '서평단 ' : '필사단 '}${item.recruitNum}명`}</MoimBadge>
                    </MoimTitleRow>
                    <MoimDesc>{item.briefIntroduction || '-'}</MoimDesc>
                    <MoimTags>{item.tags || (item.hashtags && item.hashtags.length > 0 ? '#'+item.hashtags.join(' #') : '')}</MoimTags>
                  </MoimInfo>
                </MoimItem>
              ))}
            </MoimList>
          </>
        
      </ContentSection>

      {/* 마감임박 모달 */}
      {showDeadlineModal && (
        <EventListModal 
          eventTitle="마감임박" 
          closeBtnClick={() => setShowDeadlineModal(false)} 
          eventList={modalDeadlineList} 
          eventListItemClick={handleBookEventItemClick} 
          onScroll={handleDeadlineScroll} 
          modalLoading={modalLoading} 
          hasMoreList={hasMoreDeadline} 
        />
      )}

      {/* 신규 서평단 모집 모달 */}
      {showNewModal && (
        <EventListModal 
          eventTitle="신규 서평단 모집" 
          closeBtnClick={() => setShowNewModal(false)} 
          eventList={modalNewList} 
          eventListItemClick={handleBookEventItemClick} 
          onScroll={handleNewScroll} 
          modalLoading={modalLoading} 
          hasMoreList={hasMoreNew} 
        />
      )}

      {/* 이벤트 상세 모달 */}
      {showEventDetailModal && (
        <EventDetailModal 
          bookEventId={selectedBookEventId} 
          onClose={closeEventDetailModal}
        />
      )}

      {/* 수정 모달 */}
      {showEditModal && (
        <EditModal>
          <EditModalHeader>
            <EditModalTitle>서평·필사단 모집하기</EditModalTitle>
            <CloseButton onClick={closeEditModal}>
              <FaTimes />
            </CloseButton>
          </EditModalHeader>
          <EditModalContent>
            <MoimRecruitPage editBookEventId={null} onClose={closeEditModal} />
          </EditModalContent>
        </EditModal>
      )}
    </PageWrapper>
  );
}

export default ReviewMoimPage; 